<template>
    <div class="wrapper">
        <dash-header></dash-header>
        <sidebar></sidebar>
        <div class="content-wrapper">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-4">
                                    <figure>
                                        <img :src="fund.image" class="w-100" alt="">
                                    </figure>
                                </div>
                                <div class="col-lg-8">
                                    <h3 class="fw-bold">{{fund.name}}</h3>

                                    <div class="row">
                                        <div class="col-6">
                                            <p class="title">Risk Level</p>
                                            <h5 class="text">
                                                <span v-if="fund.risk_level == 3" class="badge badge-danger">HIGH</span>
                                                <span v-else-if="fund.risk_level == 2" class="badge badge-warning">MEDIUM</span>
                                                <span v-else-if="fund.risk_level == 1" class="badge badge-success">LOW</span>
                                                <span v-else>-</span>
                                            </h5>
                                        </div>
                                        <!-- <div class="col-6">
                                            <p class="title">Trade Report</p>
                                            <p class="text">
                                                <a :href="fund.trade_report_file" target="_blank" rel="noopener noreferrer">
                                                    <svg id="file_download_icon" xmlns="http://www.w3.org/2000/svg" width="13.473" height="16" viewBox="0 0 13.473 16">
                                                        <path id="Icon_material-insert-drive-file" data-name="Icon material-insert-drive-file" d="M7.486,3A1.5,1.5,0,0,0,6.007,4.519L6,16.675a1.5,1.5,0,0,0,1.479,1.519H16.4a1.507,1.507,0,0,0,1.486-1.519V7.558L13.431,3Z" transform="translate(-6 -3)" fill="#1b1b1b" opacity="0.5"/>
                                                        <path id="Path_329" data-name="Path 329" d="M0,0,4.558,4.558H1.013A1.013,1.013,0,0,1,0,3.545Z" transform="translate(7.381 0)" fill="#1b1b1b"/>
                                                        <path id="Icon_awesome-long-arrow-alt-down" data-name="Icon awesome-long-arrow-alt-down" d="M4.647,9.936V6.69a.271.271,0,0,0-.271-.271H3.112a.271.271,0,0,0-.271.271V9.936H1.8a.542.542,0,0,0-.383.925L3.361,12.8a.542.542,0,0,0,.766,0L6.07,10.861a.542.542,0,0,0-.383-.925Z" transform="translate(7.243 3.037)" fill="#1b1b1b"/>
                                                    </svg>
                                                </a>
                                            </p>
                                        </div> -->
                                        <div class="col-12">
                                            <p class="title">Strategy</p>
                                            <p class="text">
                                                {{fund.strategy ? fund.strategy : '-'}}
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title">
                                                Last updated at : <span class="badge badge-light">{{fund.updated_at | moment}}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="d-flex justify-content-beetwen my-3">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" value="" v-model="checked" id="flexCheckDefault">
                                                <label class="form-check-label" for="flexCheckDefault">
                                                    I have read the details and willing to proceed
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="button">
                                                <button type="button" @click="sendName(fund)" :disabled="!checked" class="btn btn_red" data-toggle="modal" data-target="#chooseFund">
                                                    Choose Trader
                                                </button>
                                                <!-- <router-link :to="fund.id+'/broker/'" class="btn btn_red">Choose Trader</router-link> -->

                                                <!-- Modal -->
                                                <div class="modal fade" id="chooseFund" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                                    <div class="modal-dialog modal-dialog-centered">
                                                        <div class="modal-content">
                                                            <div class="modal-body">
                                                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                                    <span aria-hidden="true">&times;</span>
                                                                </button>
                                                                <div class="text-center">
                                                                    <img src="../assets/not-available.svg" width="200" class="mb-3" alt="">
                                                                    <h3 class="title">{{fundName}}</h3>
                                                                    <p>This feature is not yet available!</p>
                                                                </div>
                                                                <!-- <div class="text-center">
                                                                    <h3 class="title">{{fundName}}</h3>
                                                                    <p>Are you sure to choose this fund manager?</p>
                                                                </div>

                                                                <form @submit.prevent="handleProduct()">
                                                                    <input type="hidden" v-model="product.investor_id" class="form-control" readonly >
                                                                    <input type="hidden" v-model="product.product_id" class="form-control" readonly >
                                                                    <input type="hidden" v-model="product.product_type" class="form-control" readonly >
                                                                    <div class="row">
                                                                        <div class="col-6 mx-auto">
                                                                            <div class="text-center button d-flex align-items-center justify-content-center">
                                                                                <button type="button" class="btn btn_grey m-2" data-dismiss="modal">No</button>
                                                                                <button type="submit" class="btn btn_red m-2">Yes, I'm sure</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </form> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <dash-footer></dash-footer> -->
    </div>
</template>

<script>
import DashHeader from "../layouts/Header.vue";
// import DashFooter from "../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";
import axios from 'axios'

import $ from 'jquery'
import moment from "moment";

export default {
    name: "AllRobot",
    components: {
        DashHeader,
        // DashFooter,
        Sidebar,
    },
    data(){
        return{
            user_id: localStorage.getItem('user_id'),
            fund: [],
            fundName: '',
            checked: false,
            product: {
                investor_id : '',
                // broker_account_id : '',
                product_id : '',
                product_type : '',
                // payment_amount : '',
                // currency : '',
                // status : '',
            }
        }
    },
    async mounted(){
        window.scrollTo(0,0)
        
        await axios.get(`investor/fundmanager/${this.$route.params.id}`)
        .then(response => {
            // console.log('Fund All: ', response.data.data)
            this.fund = response.data.data
        }).catch(() => {
            // console.log('Error Fund: ', err.response)
        })
    },
    filters: {
        moment: function (date) {
            return moment(date).format('MMMM Do YYYY, h:mm:ss a');
        }
    },
    methods: {
        sendName(fund){
            this.fundName = fund.name
        },
        handleProduct(){
            let data = new FormData()
            data.append('investor_id', this.user_id)
            // data.append('broker_account_id', this.broker.id)
            data.append('product_id', this.fund.id)
            data.append('product_type', 'FUND_MANAGER')

            axios.post(`transaction/`, data)
            .then((response) => {
                // console.log(response);
                $('#chooseFund').modal('hide')
                // window.open('https://bithouse.id', '_blank')
                localStorage.setItem('transaction_id', response.data.data.id)
                this.$router.push(`${this.fund.id}/broker/`)
            }).catch(() => {
                // console.log(err.response);
            })
        },
    }
}
</script>

<style>
.content-wrapper{
    background: transparent !important;
}
.card.available-robot__card{
    border-radius: 25px;
}
.myrobot-card__heading {
    font-weight: bold;
    font-size: 18px;
}
.myrobot-card__text {
    color: rgba(0, 0, 0, 0.6);
    font-weight: bold;
    font-size: 12px;
    /* margin-top: 5px; */
}
.myrobot-card__value {
    font-weight: bold;
    margin-top: -15px;
    font-size: 12px;
}
button.myrobot-card__button {
    border-radius: 25px;
    width: 100%;
    font-weight: 500;
    font-size: 15px;
}
.myrobot-card__images {
    width: 190px;
    height: 178px;
    object-fit: cover;
    margin-bottom: 15px;
}
</style>
